import React,{useState,useContext,useRef,useEffect} from 'react'
import {Button,Alert} from 'react-bootstrap'
import {IconContext} from 'react-icons'
import {IoArrowBack} from 'react-icons/io5'
import { v4 as uuidv4 } from 'uuid';
import {BiPlus} from 'react-icons/bi'
import {RiDeleteBin6Fill} from 'react-icons/ri'
import {MdEdit} from 'react-icons/md'
import {FaPercentage} from 'react-icons/fa'
import {IoLanguageSharp} from 'react-icons/io5'
import EmptyList from '../../../components/EmptyList/index.js'
import axios from 'axios'
import AuthContext from '../../../context/AuthContext.js'
import PrefixContext from '../../../context/PrefixContext.js'
import Input from '../../../components/Input/index.js'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

function SingleLanguage(props){
    return(<>
        <div className="d-flex justify-content-between align-items-center bg-light border px-3 py-2">
            <div className="mb-2 d-flex align-items-center">
                <p className="mb-0">{props.element.name}&nbsp;</p>
                <small>{props.element.percentage &&  ' ( '+props.element.percentage+' )'}</small>
            </div>
            <div className="d-flex">
                <span className="p-3 text-right p-md-3 cursor-pointer" style={{display:"grid"}} onClick={()=>{props.setupEditActivity(props.element._id);}}><MdEdit/></span>
                <span className="p-3 text-right p-md-3 cursor-pointer" style={{display:"grid"}} onClick={()=>props.deleteActivity(props.element._id)}><RiDeleteBin6Fill/></span>
            </div>
        </div>
    </>)
}

function Index(props) {
    
    const inputName = useRef(null);
    const inputPercentage = useRef(null);
    const AuthContextData = useContext(AuthContext);
    const PrefixContextData = useContext(PrefixContext);
    const [internalState, setinternalState] = useState('DEFAULT')
    const [data, setdata] = useState([...props.languages])
    const [editdata, seteditdata] = useState()
    const defaultValidation = {
        validationStatus: null,
        validationStatusClass: null,
        validationStatusMessage: null,
        validationStatusLocation: null
    }
    const [validation,setValidation] = useState(defaultValidation);
    const [showButton,setshowButton] = useState(false);
    const changeState = (text) => {
        setinternalState(text)
    }
    const addActivity = (e) =>{
        e.preventDefault();
        if( validation.validationStatus !== 'LOADING')
        {
            setValidation(defaultValidation);
            const newData = [...data]
            const newItem = {name:inputName.current.value,percentage:inputPercentage.current.value}
            newData.push(newItem)
            setValidation({
                validationStatus: 'LOADING',
                validationStatusClass:'warning',
                validationStatusMessage: 'Please wait updating ...',
                validationStatusLocation: 'ADD'
            });
            axios.post(PrefixContextData.prefixUrl + 'data/edit/languages/'+props.handlerID, newData)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                        validationStatusLocation: 'ADD'
                    });
                    if(response.data.successMessageDetails !== undefined && response.data.successMessageDetails.savedDataset !== undefined && response.data.successMessageDetails.savedDataset !== null)
                    {
                        props.refreshData(response.data.successMessageDetails.savedDataset)
                    }
                    setdata(newData);
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                    else{
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.response.data.errorMessage,
                            validationStatusLocation: 'ADD'
                        });
                    }
                }
                else{
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.message,
                        validationStatusLocation: 'ADD'
                    });
                }
            });
        }
    }
    const deleteActivity = (deleteId) =>{
        if( validation.validationStatus !== 'LOADING')
        {
            setValidation(defaultValidation);
            const newData = [...data]
            var dIndex = newData.findIndex(function(el){
                return el._id === deleteId;
            })
            if (dIndex !== -1){
                newData.splice(dIndex, 1);
            }
            setValidation({
                validationStatus: 'LOADING',
                validationStatusClass:'warning',
                validationStatusMessage: 'Please wait updating ...',
                validationStatusLocation: 'DEFAULT'
            });
            axios.post(PrefixContextData.prefixUrl + 'data/edit/languages/'+props.handlerID, newData)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                        validationStatusLocation: 'DEFAULT'
                    });
                    if(response.data.successMessageDetails !== undefined && response.data.successMessageDetails.savedDataset !== undefined && response.data.successMessageDetails.savedDataset !== null)
                    {
                        props.refreshData(response.data.successMessageDetails.savedDataset)
                    }
                    setdata(newData);
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                    else{
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.response.data.errorMessage,
                            validationStatusLocation: 'DEFAULT'
                        });
                    }
                }
                else{
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.message,
                        validationStatusLocation: 'DEFAULT'
                    });
                }
            });
        }
    }
    const setupEditActivity = (editID) =>{
        let dataToBeEdited = data.filter((el)=>{
            return el._id === editID
        })
        seteditdata(dataToBeEdited[0])
        setinternalState('EDIT')
    }
    const editActivity = (e) =>{
        e.preventDefault();
        if( validation.validationStatus !== 'LOADING')
        {
            setValidation(defaultValidation);
            const newData = [...data]
            const newEditedData = newData.map((el)=>{
                if(el._id === editdata._id){
                    return {
                        _id:el._id,
                        name:inputName.current.value,
                        percentage:inputPercentage.current.value
                    }
                }
                else{
                    return el
                }
            })
            axios.post(PrefixContextData.prefixUrl + 'data/edit/languages/'+props.handlerID, newEditedData)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                        validationStatusLocation: 'EDIT'
                    });
                    if(response.data.successMessageDetails !== undefined && response.data.successMessageDetails.savedDataset !== undefined && response.data.successMessageDetails.savedDataset !== null)
                    {
                        props.refreshData(response.data.successMessageDetails.savedDataset)
                    }
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                    else{
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.response.data.errorMessage,
                            validationStatusLocation: 'EDIT'
                        });
                    }
                }
                else{
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.message,
                        validationStatusLocation: 'EDIT'
                    });
                }
            });
        }
    }
    useEffect(() => {
        setdata([...props.languages])
    }, [internalState,props.languages])

    function saveDraggedData(){
        axios.post(PrefixContextData.prefixUrl + 'data/edit/languages/'+props.handlerID, data)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                        validationStatusLocation: 'DEFAULT'
                    });
                    if(response.data.successMessageDetails !== undefined && response.data.successMessageDetails.savedDataset !== undefined && response.data.successMessageDetails.savedDataset !== null)
                    {
                        props.refreshData(response.data.successMessageDetails.savedDataset)
                    }
                    setshowButton(false);
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                    else{
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.response.data.errorMessage,
                            validationStatusLocation: 'DEFAULT'
                        });
                    }
                }
                else{
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.message,
                        validationStatusLocation: 'DEFAULT'
                    });
                }
                setshowButton(true);
            });
    }
    function handleOnDragEnd(result) {
        if (!result.destination) return;
        const newDraggedData = JSON.parse(JSON.stringify(data));
        const [reorderedItem] = newDraggedData.splice(result.source.index, 1);
        newDraggedData.splice(result.destination.index, 0, reorderedItem);
        setdata(newDraggedData);
        setshowButton(true);
    }

    return (
        <>
            {(internalState === 'DEFAULT') && 
            <>
                <h5 className="py-3">Edit Languages Data</h5>
                {(validation.validationStatus !== null && validation.validationStatusLocation ==='DEFAULT' && validation.validationStatus !== undefined)  && <div className="text-center">
                    <Alert className="d-inline-block" variant={validation.validationStatusClass}>&nbsp;&nbsp;{validation.validationStatusMessage}</Alert>
                </div>}
                <div className="d-flex justify-content-end mb-3">
                    <div className="d-flex align-items-center cursor-pointer text-primary" onClick={()=>changeState('ADD')}>
                        <BiPlus/> &nbsp;
                        <span>
                            Add Languages
                        </span>
                    </div>
                </div>
                <div className="modal-container">
                {
                    (data !== undefined && data !== null) ? 
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <Droppable droppableId="languages">
                            {(provided) => (
                                <span className="drop-container" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                {data.map((element,index) => {
                                    return (
                                        <Draggable key={element._id} draggableId={element._id} index={index}>
                                            {(provided) => (
                                                <div className="mb-3" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                    <SingleLanguage key={uuidv4()} setupEditActivity={setupEditActivity} deleteActivity={deleteActivity} element={element}/>
                                                </div>
                                            )}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                                </span>
                            )}
                        </Droppable>
                    </DragDropContext>
                    :
                    <div className="w-50 mx-auto">
                        <EmptyList type="withImage" label="No Languages Data Added"/>
                    </div>
                }
                </div>
                <div className="d-flex p-3 justify-content-between">
                    <Button variant='white' className="border border-black" onClick={props.goBack}>
                        <div className="d-flex align-items-center">
                            <IconContext.Provider value={{color:'#6c757d'}}>
                                <IoArrowBack/> &nbsp;
                            </IconContext.Provider>
                            <p className="text-secondary mb-0">Go Back</p>
                        </div>
                    </Button>
                    {showButton  && <Button className="px-3 py-2" onClick={(e)=>{saveDraggedData(e)}}>
                        <div className="d-flex align-items-center">
                            <p className="mb-0">Save</p>
                        </div>
                    </Button>}
                </div>
            </>}
            {(internalState === 'ADD') && 
            <>
                <h5 className="py-3">Add Languages</h5>
                {(validation.validationStatus !== null && validation.validationStatusLocation ==='ADD' && validation.validationStatus !== undefined)  && <div className="text-center">
                    <Alert className="d-inline-block" variant={validation.validationStatusClass}>&nbsp;&nbsp;{validation.validationStatusMessage}</Alert>
                </div>}
                <form onSubmit={(e)=>{addActivity(e)}} className="modal-container">
                    <Input type="text" name="name" initRef={inputName} placeholder='Language' icon={<IoLanguageSharp/>}/>
                    <Input type="text" name="percentage" initRef={inputPercentage} placeholder='Percentage' icon={<FaPercentage/>}/>
                    <div className="d-flex p-3 justify-content-between">
                        <Button variant='white' className="border border-black" onClick={()=>{changeState('DEFAULT');setValidation(defaultValidation);}}>
                            <div className="d-flex align-items-center">
                                <IconContext.Provider value={{color:'#6c757d'}}>
                                    <IoArrowBack/> &nbsp;
                                </IconContext.Provider>
                                <p className="text-secondary mb-0">Go Back</p>
                            </div>
                        </Button>
                        <Button className="px-3 py-2" onClick={(e)=>{addActivity(e)}}>
                            <div className="d-flex align-items-center">
                                <p className="mb-0">Add</p>
                            </div>
                        </Button>
                    </div>
                </form>
            </>}
            {(internalState === 'EDIT') && 
            <>
                <h5 className="py-3">Edit Language Data</h5>
                {(validation.validationStatus !== null && validation.validationStatusLocation ==='EDIT' && validation.validationStatus !== undefined)  && <div className="text-center">
                    <Alert className="d-inline-block" variant={validation.validationStatusClass}>&nbsp;&nbsp;{validation.validationStatusMessage}</Alert>
                </div>}
                <form onSubmit={(e)=>{addActivity(e)}} className="modal-container">
                    <Input type="text" defaultValue={editdata.name} name="name" initRef={inputName} placeholder='Language' icon={<IoLanguageSharp/>}/>
                    <Input type="text" defaultValue={editdata.percentage} name="percentage" initRef={inputPercentage} placeholder='Percentage' icon={<FaPercentage/>}/>
                    <div className="d-flex p-3 justify-content-between">
                        <Button variant='white' className="border border-black" onClick={()=>{changeState('DEFAULT');setValidation(defaultValidation);}}>
                            <div className="d-flex align-items-center">
                                <IconContext.Provider value={{color:'#6c757d'}}>
                                    <IoArrowBack/> &nbsp;
                                </IconContext.Provider>
                                <p className="text-secondary mb-0">Go Back</p>
                            </div>
                        </Button>
                        <Button className="px-3 py-2" onClick={(e)=>{editActivity(e)}}>
                            <div className="d-flex align-items-center">
                                <p className="mb-0">Add</p>
                            </div>
                        </Button>
                    </div>
                </form>
            </>}
        </>
    )
}

export default Index
